import { DashboardService } from '@go-widgets/well-logs-widget';

import { wellLogsWidgetAgent } from 'src/api/wellLogsWidgetAgent';
import type { IServicesCollection } from 'src/packages/di';

declare module 'src/packages/di' {
  export interface ServicesCollectionMap {
    dashboardService: DashboardService;
  }
}

export async function addDashboardService(di: IServicesCollection): Promise<void> {
  di.addSingleton('dashboardService', new DashboardService(wellLogsWidgetAgent));
}
